import { c as _c } from "react/compiler-runtime";
import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { UserGroupListItem } from '../UserGroupListItem/UserGroupListItem';
export type UserGroupListProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  userGroups: Array<UserGroup>;
};
export const UserGroupList: FunctionComponent<UserGroupListProps> = React.memo(props => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      userGroups,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true
    });
    t0 = remainingProps;
    t1 = userGroups.map(_temp);
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = <div {...t0}>{t1}</div>;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
});
function _temp(ug) {
  return <UserGroupListItem key={EntityUtils.getTrackingKey(ug)} userGroup={ug} data-testid="UserGroupList.ListItem" />;
}